import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { CancelWorkflowButton } from '../actions/CancelWorkflowButton';
import { SaveWorkflowButton } from '../actions/SaveWorkflowButton';

interface WorkflowDetailsHeaderProps {
  onSave: () => void;
  onCancel?: () => void;
  workflowName: string;
}

export const WorkflowDetailsHeader: React.FC<WorkflowDetailsHeaderProps> = ({ onSave, onCancel, workflowName }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5 }}>
          Edit Workflow
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          {workflowName || 'Configure workflow settings, conditions, and steps'}
        </Typography>
      </Box>
      <Stack direction="row" spacing={2}>
        <CancelWorkflowButton onCancel={onCancel} />
        <SaveWorkflowButton onClick={onSave} />
      </Stack>
    </Box>
  );
};

export default WorkflowDetailsHeader;
